import PageHeader from '../components/general/pageHeader.js';
import PortfolioTable from '../components/portfolio/portfolioTable.js';

import '../styles/global.css';

const Portfolio = () => {
    return (
        <div className="w-full">
            <PageHeader pageName="Property Portfolio" />
            <PortfolioTable />
        </div>
    );
};

export default Portfolio;
